import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import getConfig from '../../../util/config';
import { getAsset } from '../../../util/assets';

const propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  videoUrl: PropTypes.string,
};

const HeadOpenGraphMeta = ({
  children,
  title,
  description,
  imageUrl,
  videoUrl,
}) => {
  const {
    app: { pageUrl },
  } = getConfig();

  const fallbackImageUrl = getAsset('/og-link-preview-fallback.png');

  return (
    <Helmet>
      <title>{title} &ndash; Waldo Photos</title>
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title} - Waldo Photos`} />
      {description && <meta property="og:description" content={description} />}
      {(imageUrl || fallbackImageUrl) && !videoUrl && (
        <meta property="og:image" content={imageUrl || fallbackImageUrl} />
      )}
      {videoUrl && <meta property="og:video" content={videoUrl} />}
      {children}
    </Helmet>
  );
};

HeadOpenGraphMeta.propTypes = propTypes;

export default HeadOpenGraphMeta;
